<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindReport=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/financereport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="transactions.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" sm="12" md="12" lg="12" >
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px; vertical-align: top;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table v-if="data!=null" style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Report Date</span></td>
                            <td v-if="data!=null && data.length>0" style="text-align: right"><span style="font-size: 11pt;">{{ new Date(data[0].report_date).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                  <p style="margin-top: 0; margin-bottom: 10px">&nbsp;</p>
                  <table style="width: 100%; padding-bottom: 10px;">
                    <tr>
                      <td>
                        <div align="center" style="padding: 0; line-height: 0;"><h3><b>{{ this.reporttitle }}</b></h3></div>
                      </td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </table>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr>
                      <th :style="css['row-bottom-left']">Vendor</th>
                      <th :style="css['row-bottom-right']" width="14%">Balance</th>
                      <th :style="css['row-bottom-right']" width="14%">0-30</th>
                      <th :style="css['row-bottom-right']" width="14%">31-60</th>
                      <th :style="css['row-bottom-right']" width="14%">61-90</th>
                      <th :style="css['row-bottom-right']" width="14%">90+</th>
                    </tr>
                  </tbody>
                  <tbody v-if="transactions.length!=0">
                    <tr v-for="(trans) in transactions"  v-bind:key="trans._id">
                      <td :style="css['row-left']">{{ trans.customername }}</td>  
                      <td :style="css['row-right']">{{ (trans['balance']).toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ (trans['days_0']).toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ (trans['days_31']).toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ (trans['days_61']).toFixed(1) }}</td>
                      <td :style="css['row-right']">{{ (trans['days_90']).toFixed(1) }}</td>
                    </tr>
                    <tr>
                      <td :style="css['row-right-end']"></td>
                      <td :style="css['row-right-end']">{{ sum_total['balance'].toFixed(1) }}</td>
                      <td :style="css['row-right-end']">{{ sum_total['days_0'].toFixed(1) }}</td>
                      <td :style="css['row-right-end']">{{ sum_total['days_31'].toFixed(1) }}</td>
                      <td :style="css['row-right-end']">{{ sum_total['days_61'].toFixed(1) }}</td>
                      <td :style="css['row-right-end']">{{ sum_total['days_90'].toFixed(1) }}</td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="isFindReport"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_startdate"
                  v-model="menu_startdate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.startdate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col> -->
              <v-col cols="12" sm="12" md="12">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindReport = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetReport"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
    import {mapActions} from "vuex";
    import { getLogo, formatStdDate } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            isFindReport: false,
            menu_startdate: null,
            menu_enddate: null,
            companycode: null,
            reportname: 'AR_Aging',
            reporttitle: 'Accounts Receivable Aging',
            digits: null,
            find_query: {},
            data: {},
            transactions: [],
            sum_transactions: {},
            css: {
              'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid;',
              'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-weight: bold;',
              'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-left': 'font-size: 10pt; text-align: left; padding: 5px; vertical-align: top; border-bottom: 1px; border-bottom-style: solid;',
              'row-right': 'font-size: 10pt; text-align: right; padding: 5px;border-bottom: 1px; border-bottom-style: solid;',
              'row-left-end': 'font-size: 11pt; text-align: left; padding-top: 10px; vertical-align: top; border-top: 2px; border-top-style: solid;',
              'row-right-end': 'font-size: 11pt; text-align: right; padding-top: 10px;border-top: 2px; border-top-style: solid;',
            },
            formatStdDate: formatStdDate,
          };
        },
        computed: {
          reportdate(){
            if(this.data.length>0) return this.data[0].report_date;
            return '';
          },
          sum_total(){
            if(this.transactions==null || this.transactions.length==0) return {balance: 0, days_0: 0, days_31: 0, days_61: 0, days_90: 0};
            let result = {
              balance: this.transactions.reduce(function (last, json) {return last + json.balance;}, 0),
              days_0: this.transactions.reduce(function (last, json) {return last + json.days_0;}, 0),
              days_31: this.transactions.reduce(function (last, json) {return last + json.days_31;}, 0),
              days_61: this.transactions.reduce(function (last, json) {return last + json.days_61;}, 0),
              days_90: this.transactions.reduce(function (last, json) {return last + json.days_90;}, 0),
              isSum: true,
            }
            return result;
          },
        },
        methods: {
          ...mapActions('FinanceReport', ["findFinanceReportReceivablesAgingRequest", "getFinanceReportReceivablesAgingRequest"]),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html>');
            mywindow.document.write('<head><title>'+ `${this.companycode} ${this.reportname} ${ this.formatStdDate(this.reportdate) }` + '</title></head>');
            mywindow.document.write('<body onclick="window.print();">');  
            mywindow.document.write(content);
            mywindow.document.write('</body>');
            mywindow.document.write('</html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          getTransactions(){
            this.transactions = [];
            this.report_date = this.data.length>0 ? new Date(this.data[0]['report_date']) : new Date();
            let categories = ['0-30', '31-60', '61-90', '90-'];
            let object = Object.groupBy(this.data, item => { return item.customerid });
            let customers = Object.keys(object);

            for(var item of customers){
              let balance;
              let customername = item!='null' ? this.data.find(x=>x.customerid==item)['customername'] : 'None';
              if(item=='null') balance = this.data.filter(x=>x.customerid==null).reduce(function (last, json) {return last + json.balance;}, 0);
              else balance = this.data.filter(x=>x.customerid==item).reduce(function (last, json) {return last + json.balance;}, 0);

              let json = {
                customerid: item,
                customername: customername,
                balance: balance,
              };
              for(var cat of categories){
                let text = cat.split("-")[0];
                let find = this.data.find(x=>x.customerid==item && x.due_class==cat);
                json[`days_${text}`] = find!=null ? find.balance : 0;
              }
              this.transactions.push(json);
            }
          },
          resetReport(){
            this.find_query = {};
          },
          async findReport(){
            this.data = await this.findFinanceReportReceivablesAgingRequest(this.find_query);
            this.getTransactions();
            this.isFindReport = false;
          },
          getFileName(){
            var name = `${this.companycode} ${this.reportname}` + ' ' + `${formatStdDate(this.reportdate)}` ;
            return name + '.xls';
          },
          getJson(){
            let jsons = [];
            for(var item of this.transactions){
              let json = {
                reportdate: this.formatStdDate(this.reportdate),
                customer: item.customername,
                'balance': item.balance,
                '0_30': item['days_0'],
                '31_60': item['days_31'],
                '61_90': item['days_61'],
                '90+': item['days_90'],
              }
              jsons.push(json);
            }
            return jsons;
          },
        },
        async created () {
          this.data = await this.getFinanceReportReceivablesAgingRequest();
          this.getTransactions();
          var companyid = localStorage.getItem("companyid");
          this.companycode = localStorage.getItem("companycode");
          this.logo = getLogo(companyid);
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
